import { all, call, Effect, fork, put, takeLatest } from 'redux-saga/effects';
import { standardiseError } from '../../utils/error';
import { normalise } from '../../utils/request';
import { getCurrentLocationAction, setCurrentLocationAction, setLocationErrorAction } from './actions';
import { getLocation, Response } from './api';

export function* handleGetCurrentLocation(action: ReturnType<typeof getCurrentLocationAction>): Generator<Effect> {
  const locationId = action.payload.selectedItemId;
  try {
    const response = (yield call(getLocation, locationId)) as Response;
    yield put(setCurrentLocationAction({ location: normalise(response) }));
  } catch (e) {
    const error = standardiseError(e);
    yield put(setLocationErrorAction({ error, selectedItemId: locationId }));
  }
}

function* watchGetCurrentLocation() {
  yield takeLatest(getCurrentLocationAction, handleGetCurrentLocation);
}

export function* locationSagas(): Generator<Effect> {
  yield all([fork(watchGetCurrentLocation)]);
}
